<template>
  <div class="container py-4">
    <h2 class="mb-4 fw-bold">📰 Последние новости</h2>

    <div class="row g-4">
      <div v-for="news in newsList" :key="news.id" class="col-12">
        <router-link
          :to="`/public/news/${news.id}`"
          class="post row align-items-center text-decoration-none text-dark"
        >
          <div class="col-md-5">
            <div class="post-preview">
              <img
                :src="news.image_url || noPhoto"
                alt="article"
                class="img-fluid rounded shadow-sm"
                style="max-width: 300px; max-height: 300px; object-fit: cover"
              />
            </div>
          </div>
          <div class="col-md-7">
            <div class="post-wrapper">
              <h2 class="post-title h5 fw-semibold mb-2">{{ news.title }}</h2>
              <ul class="post-meta list-unstyled d-flex gap-3 small text-muted mb-2">
                <li>{{ formatDate(news.published_at) }}</li>
                <li>{{ news.category?.name }}</li>
              </ul>
              <p class="text-secondary small">
                {{ extractPlainText(news.content) }}
              </p>
              <router-link :to="`/public/news/${news.id}`">Открыть</router-link>
            </div>
          </div>
        </router-link>
      </div>
    </div>

    <!-- Loader / Sentinel -->
    <div ref="sentinel" class="text-center mt-4" v-if="!isEnd">
      <div class="spinner-border text-secondary" role="status">
        <span class="visually-hidden">Загрузка...</span>
      </div>
    </div>

    <!-- Сообщение, если всё загружено -->
    <p class="text-center mt-4 text-muted" v-if="isEnd">
      Все новости загружены.
    </p>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import axios from 'axios'

const newsList = ref([])
const currentPage = ref(1)
const totalPages = ref(1)
const isLoading = ref(false)
const isEnd = ref(false)
const noPhoto = '/images/no-photo.png'

const observer = ref(null)
const sentinel = ref(null)

const loadNews = async () => {
  if (isLoading.value || isEnd.value) return
  isLoading.value = true

  try {
    const res = await axios.get(`/api/v1/news?page=${currentPage.value}`)
    const data = res.data.news

    if (data.length > 0) {
      newsList.value.push(...data)
      totalPages.value = Math.ceil(res.data.pagination.total / res.data.pagination.per_page)

      if (currentPage.value >= totalPages.value) {
        isEnd.value = true
      } else {
        currentPage.value++
      }
    } else {
      isEnd.value = true
    }
  } catch (e) {
    console.error('Ошибка при загрузке новостей:', e)
  } finally {
    isLoading.value = false
  }
}

const formatDate = (dateString) => {
  if (!dateString) return ''
  return new Date(dateString).toLocaleDateString('ru-RU')
}

const extractPlainText = (htmlContent) => {
  return htmlContent?.replace(/<[^>]*>/g, '').slice(0, 800) || ''
}

const setupObserver = () => {
  if (observer.value) observer.value.disconnect()

  observer.value = new IntersectionObserver(
    (entries) => {
      if (entries[0].isIntersecting) {
        loadNews()
      }
    },
    {
      rootMargin: '200px',
    }
  )

  if (sentinel.value) {
    observer.value.observe(sentinel.value)
  }
}

onMounted(() => {
  loadNews()
  setupObserver()
})

onUnmounted(() => {
  if (observer.value) observer.value.disconnect()
})
</script>
